import { Box, Container, H3, IoArrowForward, Link, Section, themeGet } from 'react-components';
import React, { PropsWithChildren } from 'react';
import { formatDate } from 'shared/utils/date-utils';
import styled from 'styled-components';

export interface LinksSectionProps {
  title: string;
  links: {
    id: string;
    date: Date;
    title: string;
    link: {
      text: string;
      url: string;
    };
  }[];
}

const StyledRouterLink = styled(Link)`
  &:hover > * {
    color: ${themeGet('colors.success.success40')};
    text-decoration: underline;
  }
`;

export const LinksSection: React.FunctionComponent<PropsWithChildren<LinksSectionProps>> = ({
  title,
  links,
}) => {
  return (
    <Section bg="black">
      <Container
        display="grid"
        gridTemplateColumns={{ _: '1fr', sm: 'repeat(2, minmax(0, 1fr))' }}
        py="3rem"
      >
        <Box mr={{ sm: '6rem' }}>
          <H3 color="white" opacity="0.6" my={0} fontSize={{ _: '2rem', sm: '3rem' }} mb="3rem">
            {title}
          </H3>
        </Box>
        <Box>
          {links.map(({ date, title, link, id }) => {
            return (
              <Box
                key={id}
                position="relative"
                pb={{ _: 4, sm: 4 }}
                mb={{ _: 4, sm: '3rem' }}
                borderBottomStyle="solid"
                borderBottomColor="blacks.black800"
              >
                <Box color="blacks.black600" display={{ _: 'none', sm: 'block' }}>
                  {formatDate(date)}
                </Box>
                <H3 color="white" my={2} fontSize={{ _: '2rem', sm: '3rem' }}>
                  {title}
                </H3>
                <StyledRouterLink href={link.url} $clickOverlay={true}>
                  <Box
                    as="span"
                    display="flex"
                    alignItems="center"
                    color="success.success50"
                    gridGap={2}
                    fontSize={4}
                  >
                    <IoArrowForward /> {link.text}
                  </Box>
                </StyledRouterLink>
              </Box>
            );
          })}
        </Box>
      </Container>
    </Section>
  );
};
